/**
 * zh / en translations for main page and knowledge base page.
 * Use t.key in components; for params use t.key then replace e.g. title.replace('{title}', value).
 */
export const zh = {
  loading: '加载中...',
  noData: '暂无数据',
  refresh: '刷新',
  refreshing: '刷新中...',
  confirm: '确认',
  cancel: '取消',
  close: '关闭',
  processing: '处理中...',

  knowledgeBase: '知识库',
  conversationList: '对话列表',
  customerList: '客户列表',
  filterByStage: '按阶段筛选',
  allStages: '全部阶段',
  customerId: '客户ID',
  name: '姓名',
  phone: '手机',
  email: '邮箱',
  stage: '阶段',
  createdAt: '创建时间',
  actions: '操作',
  deleteCustomer: '删除客户',
  deleting: '删除中...',
  confirmDelete: '确认删除',
  delete: '删除',
  confirmDeleteCustomerMessage: '您确定要删除客户',
  confirmDeleteCustomerSuffix: ' 吗？',
  confirmDeleteCustomerNote: '此操作无法撤销。该客户及其所有关联的对话记录将被永久删除。',

  refreshConversationList: '刷新对话列表',
  customer: '客户',
  conversationCount: '轮对话',
  round: '第 {n} 轮',
  userLabel: '用户:',
  aiLabel: 'AI:',
  confirmDeleteConversations: '您确定要删除该客户的所有对话吗？',
  conversationDetail: '对话详情',
  userMessage: '用户消息',
  aiResponse: 'AI 回复',

  customerServiceCenter: '客户服务中心',
  newConversation: '新对话',
  newConversationTitle: '开始新对话',
  welcomeMessage: '您好！欢迎来到{title}，有什么可以帮助您的吗？',
  inputPlaceholder: '请输入您的消息...',
  send: '发送',

  updateFailed: '更新失败：',
  unknownError: '未知错误',
  updateStageError: '更新客户阶段时出错，请重试。',
  deleteFailed: '删除失败：',
  deleteCustomerError: '删除客户时出错，请重试。',
  deleteError: '删除时出错，请重试。',
  sessionFailed: '获取会话失败',
  processError: '处理出错',
  connectionInterrupted: '连接中断，请重试。',
  connectionFailed: '连接失败，请重试。',

  kbTitle: '知识库 · {code}',
  backToHome: '返回主页',
  kbRecords: '知识库记录',
  usageLogForRecord: '该条记录的使用日志',
  selectRecordHint: '请从左侧选择一条知识库记录',
  noUsageRecords: '暂无使用记录',
  allUsageLogs: '全部使用日志（按时间倒序）',
  content: '内容',
  customerQuestion: '客户问题',
  similarity: '相似度',
  time: '时间',
};

export const en = {
  loading: 'Loading...',
  noData: 'No data',
  refresh: 'Refresh',
  refreshing: 'Refreshing...',
  confirm: 'Confirm',
  cancel: 'Cancel',
  close: 'Close',
  processing: 'Processing...',

  knowledgeBase: 'Knowledge Base',
  conversationList: 'Conversations',
  customerList: 'Customers',
  filterByStage: 'Filter by Stage',
  allStages: 'All Stages',
  customerId: 'Customer ID',
  name: 'Name',
  phone: 'Phone',
  email: 'Email',
  stage: 'Stage',
  createdAt: 'Created At',
  actions: 'Actions',
  deleteCustomer: 'Delete Customer',
  deleting: 'Deleting...',
  confirmDelete: 'Confirm Delete',
  delete: 'Delete',
  confirmDeleteCustomerMessage: 'Are you sure you want to delete customer',
  confirmDeleteCustomerSuffix: '?',
  confirmDeleteCustomerNote: 'This cannot be undone. All conversations for this customer will be permanently deleted.',

  refreshConversationList: 'Refresh conversation list',
  customer: 'Customer',
  conversationCount: 'conversation(s)',
  round: 'Round {n}',
  userLabel: 'User:',
  aiLabel: 'AI:',
  confirmDeleteConversations: 'Are you sure you want to delete all conversations for this customer?',
  conversationDetail: 'Conversation Detail',
  userMessage: 'User Message',
  aiResponse: 'AI Response',

  customerServiceCenter: 'Customer Service Center',
  newConversation: 'New Conversation',
  newConversationTitle: 'Start new conversation',
  welcomeMessage: 'Hello! Welcome to {title}. How can we help you?',
  inputPlaceholder: 'Type your message...',
  send: 'Send',

  updateFailed: 'Update failed: ',
  unknownError: 'Unknown error',
  updateStageError: 'Failed to update customer stage. Please try again.',
  deleteFailed: 'Delete failed: ',
  deleteCustomerError: 'Failed to delete customer. Please try again.',
  deleteError: 'Delete failed. Please try again.',
  sessionFailed: 'Failed to get session',
  processError: 'Processing error',
  connectionInterrupted: 'Connection interrupted. Please try again.',
  connectionFailed: 'Connection failed. Please try again.',

  kbTitle: 'Knowledge Base · {code}',
  backToHome: 'Back to Home',
  kbRecords: 'Knowledge Base Records',
  usageLogForRecord: 'Usage log for this record',
  selectRecordHint: 'Please select a record from the left',
  noUsageRecords: 'No usage records',
  allUsageLogs: 'All usage logs (newest first)',
  content: 'Content',
  customerQuestion: 'Customer Question',
  similarity: 'Similarity',
  time: 'Time',
};

export function getTranslations(locale) {
  return locale === 'zh' ? zh : en;
}
